import { useTranslation } from "next-i18next";
import * as yup from "yup";
import { useFormik } from "formik";
import { EmployeeAccessData } from "./employee-model";

/**
 * Manages form data for employee data step.
 * @param onNext a call back that signals submission
 * @returns a formik instance
 */
export function useEmployeeAccessFormik(
  onNext: (data: EmployeeAccessData) => void
) {
  const { t } = useTranslation();
  const messageRequired = t("common:common.required");
  const messageTextOnly = t("common:common.text_only");
  const messageEmployeeEmail = t(
    "request_access:employee_access.employee_email_error"
  );

  const expressionTextOnly = /^([^0-9@&*"']*)$/;
  const expressionEmployeeEmail =
    /^([a-zA-Z0-9_\-\.]+)@(cargill.com|crgl-thirdparty.com)$/i;

  const validationSchema = yup.object().shape({
    dsId: yup.string().required(messageRequired),
    firstName: yup
      .string()
      .required(messageRequired)
      .matches(expressionTextOnly, messageTextOnly),
    lastName: yup
      .string()
      .required(messageRequired)
      .matches(expressionTextOnly, messageTextOnly),
    cargillRole: yup.string().required(messageRequired),
    cargillBusinessEmployee: yup.string().required(messageRequired),
    employeeRegion: yup.string().required(messageRequired),
    email: yup
      .string()
      .required(messageRequired)
      .matches(expressionEmployeeEmail, messageEmployeeEmail),
    validEmployee: yup.bool(),

    agreeToTerms: yup.boolean().oneOf([true], messageRequired),
    accessToken: yup.string().required(messageRequired),
  });

  const formik = useFormik<EmployeeAccessData>({
    initialValues: {
      dsId: "",
      firstName: "",
      lastName: "",
      cargillRole: "",
      cargillBusinessEmployee: "",
      employeeRegion: "",
      email: "",
      validEmployee: true,
      agreeToTerms: false,
      accessToken: "",
    },
    validationSchema: validationSchema,
    // use handleSubmission instead
    onSubmit: (values) => {
      onNext(values);
    },
  });

  return formik;
}
